export default "/images/vendor/flag-icons/flags/1x1/td.svg?16a25e2113c56509d1b663a067fa956b";